type NavigateToTarget = (target: Element) => boolean;

const menus = new Map<Element, NavigateToTarget>();

export function registerAnchorMenu(menu: Element, navigate: NavigateToTarget): void {
    menus.set(menu, navigate);
}

export function unregisterAnchorMenu(menu: Element): void {
    menus.delete(menu);
}

// Let the owning menu apply the same thresholds and post-scroll correction as a click.
export function scrollToAnchorMenuTarget(target: Element): boolean {
    return [...menus.values()].some((navigate) => navigate(target));
}
